export const movePrev = (list, currIdx) => {
    if (currIdx <= 0 || currIdx > list.length - 1) return null;
    const newList = [...list];
    const list2 = newList.splice(currIdx - 1);
    const value = list2.splice(1, 1);
    return newList.concat(value).concat(list2);
};

export const moveNext = (list, currIdx) => {
    if (currIdx < 0 || currIdx >= list.length - 1) return null;
    const newList = [...list];
    const list2 = newList.splice(0, currIdx + 1);
    const value = newList.splice(0, 1);
    value.push(list2.pop());
    return list2.concat(value).concat(newList);
};
